import { FC } from 'react';
import { Outlet, useOutletContext } from 'react-router';

import { StageHeader } from '@app/widgets/header';
import { CommonOutletContext } from '@app/app/layouts';

import { cn } from '../lib';

export const StageLayout: FC<{
  isWorkspaceVariant?: boolean;
  isAiChatVariant?: boolean;
}> = ({ isWorkspaceVariant = false, isAiChatVariant = false }) => {
  const context = useOutletContext<CommonOutletContext>();

  return (
    <>
      <StageHeader isWorkspaceVariant={isWorkspaceVariant} isAiChatVariant={isAiChatVariant} />
      <main
        className={cn(
          isAiChatVariant ? 'min-h-[calc(100vh-3.25rem)]' : 'min-h-[calc(100vh-5.25rem)]',
          'flex flex-col',
          isWorkspaceVariant ? 'min-w-[984px] px-5' : '',
        )}
      >
        <Outlet context={context} />
      </main>
    </>
  );
};
